import React from 'react';
import { HiOutlineCursorClick, HiOutlineIdentification, HiOutlineMenuAlt2 } from 'react-icons/hi';
import { EmailBlockKind } from '../../../../../../../types/communication';

export const BLOCK_ICONS: Record<EmailBlockKind, React.ReactNode> = {
    TEXT: <HiOutlineMenuAlt2 size={16} />,
    BUTTON: <HiOutlineCursorClick size={16} />,
    FOOTER: <HiOutlineIdentification size={16} />,
};

export const BLOCK_ORDER: EmailBlockKind[] = ['TEXT', 'BUTTON', 'FOOTER'];
